const drawerTriggers = document.querySelectorAll('.trellis-drawer__trigger')
const drawers = document.querySelectorAll('.trellis-drawer__container')

if (drawerTriggers.length && drawers.length) {
  // Drawer Trigger Click
  drawerTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetID = trigger.getAttribute('data-target');
      const targetDrawer = document.getElementById(targetID);

      targetDrawer.classList.add('active');

       document.querySelector('.product--right-area').classList.add("active");
    });
  });

  // Drawer Events
  drawers.forEach(drawer => {
    // Close Btn Click
    const closeBtn = drawer.querySelector('.close')
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      transitionOut();
    });

    // Overlay Click
    drawer.addEventListener('click', () => {
      transitionOut();
    });

    // Animation Complete
    const drawerPanel = drawer.querySelector('.trellis-drawer');
    drawerPanel.addEventListener('transitionend', () => {
      if (drawer.classList.contains('active-out')) {
        drawer.classList.remove('active', 'active-out')
        document.querySelector('.product--right-area').classList.remove("active");
      }
    });

    // Prevent Overlay Click Drom Propigating Down
    drawerPanel.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  // Transition Out
  function transitionOut() {
    const targetDrawer = document.querySelector('.trellis-drawer__container.active');
    targetDrawer.classList.add('active-out');
  }
}